var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasSsnAccess)?_c('div',{staticClass:"is-inline-flex",staticStyle:{"align-items":"center"}},[_vm._v(" "+_vm._s(_vm.ssnForDisplay || '-')+" "),(_vm.hasFeatureAccess('customer.ssn'))?_c('user-pin-control',{attrs:{"useIcon":"fa-eye"},on:{"on-pin-verified":_vm.fetchSsn}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }